import { render, staticRenderFns } from "./CalendarioServiziFilter.vue?vue&type=template&id=5301d1db&"
import script from "./CalendarioServiziFilter.vue?vue&type=script&lang=ts&"
export * from "./CalendarioServiziFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports